import {CommentInput, NoneOperationCommentForm} from "pages/dashboard/popup/noneOperation/NoneOperationCommentForm"
import {useRegisterComment} from "hooks/queries/non-oper-comment.query"
import {NoneOperationComment} from "dto/realdevice/none-operation-comment"
import {AxiosError} from "axios"

export function RegisterNoneOperationComment({eui, onSuccess, onCancel}: { eui: string, onSuccess: () => void, onCancel: () => void }) {
    const registerCommand = useRegisterComment()
    const onSubmit = async (value: CommentInput) => {
        console.log("data : ", value)
        const comment: NoneOperationComment = {
            eui: eui,
            comment: value.comment,
            fromDate: value.fromDate,
            endDate: value.endDate,
        }
        registerCommand.mutate(comment, {
            onSuccess: (data, variables, context) => {
                // console.log("success value : ", data, variables, context)
                onSuccess()
            },
            onError: (err, variables, context) => {
                const error = (err as AxiosError)
                // console.log("error value : ", error, variables, context)
            },
        })
    }
    return (
        <NoneOperationCommentForm onSubmit={onSubmit} onCancel={onCancel}/>
    )
}